export const en_52 = { 
    "common": {
        "pay": "REDEEM CODE",
        "top-up": "Prepaid Mobile Top-up",
    },
    "send_balance": {
        "store_pin_payment_msg" :"Please select \"redeem code\" below to complete the transaction. Please check your email for the receipt.",
        'balance_success': 'Prepaid Mobile Top-up Successful',
        'balance_phone_number_label': 'Prepaid Mobile Top-up phone number',
        'select_amt_label': 'Select Prepaid Mobile Top-up amt',
        "topup_heading":"Send Prepaid Mobile Top-up",
    },
    'menu' : {
        'send_balance': 'Send Prepaid Mobile Top-up',
    }
}